/* eslint-disable */
import {formatCurrency} from '../ApplicationHelpers';

export default  {
    DefaultBranding: {
        name:'Retirement Analyzer 9 to Know Context',
        phone:'800-854-6621',
        logo:"/images/ra-logo.png",
        background:'url(/images/header-bg.jpg) no-repeat center top',
        color:'#FFFFFF'
      },
    HightChartsDefaultConfig:{
        chart: {
            type: 'column',
            backgroundColor: '#ffffff',
            borderColor: '#2d4b73',
            plotBackgroundColor:'#ffffff',
            plotBorderColor: '#ffffff',
            plotShadow:true,
            color:'#FFFFFF',
            height: '300px'
        },
        plotOptions: {
            series: {
                color: '#437B0A'
            }
        },
        title: {
            text: 'Retirement Funds',
            style:{
                color:'#666666',
                fontWeight: '600',
                fontSize: '15px'
            }
        },
        xAxis: {
            type: 'category',
            labels: {
                // step:1,
                rotation: 0,
                style: {
                    color:'#666666',
                    fontSize: '12px',
                    fontWeight: '600',
                    fontFamily: "Open Sans"
                }
            },
            title: {
                text: 'Years',
                style:{
                    fontSize:'12px',
                    color:'#666666',
                    fontWeight: '600',
                    fontFamily: "Open Sans"
                }
            },
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Dollars ($)',
                style:{
                    color:'#666666',
                    fontWeight: '600',
                    fontSize:'12px',
                    fontFamily: "Open Sans"
                }
            },
            labels: {
                rotation: 0,
                style: {
                    color:'#666666',
                    fontSize: '12px',
                    fontFamily: "Open Sans",
                    fontWeight:'600'
                },
                formatter: function(){
                    if(this.value === 0) {
                        return '0';
                      } else if(this.value > 999999999) {
                        return Highcharts.numberFormat(this.value/1000000000, -1) + "B";
                      }
                       else if(this.value > 999999) {
                        return (Math.round(this.value/100000)/10)+'M';
                      } else if(this.value < -999999) {
                        return (Math.round(this.value/100000)/10)+'M';
                      } else if(this.value > 999) {
                        return (Math.round(this.value/100)/10)+'K';
                      } else if(this.value < -999) {
                        return (Math.round(this.value/100)/10)+'K';
                      }

                      return this.value;
                }
            }
        },
        legend: {
            enabled: false,
            itemStyle: {
                color:'#666666',
                fontSize: '12px',
                fontFamily: "Open Sans",
                fontWeigth: 'normal'
            }
        },
        tooltip: {
            // pointFormat: "Funds: <b>${point.y:.1f}</b>",
            backgroundColor:'#000000',
            borderColor: '#95b9e1',
            valueDecimals:2,
            useHTML: true,
            formatter: function () {
                // return `<b>${this.key}</b> ${formatCurrency(this.y)}`;
                let toolTipData = '';

                this.x ? toolTipData += `<span style='text-align:center; display: block; padding-bottom: 5px;'><b>Year ${this.key}</b></span>` : '';

                this.point.clientBirthYear ? toolTipData += `${this.point.clientFirstName}'s Age: ${this.key - this.point.clientBirthYear} Years <br>` : '';

                this.point.spouseBirthYear ? toolTipData += `${this.point.spouseFirstName}'s Age: ${this.key - this.point.spouseBirthYear} Years <br>` : '';

                this.y ? toolTipData += `Portfolio Total: ${formatCurrency(this.y)}` : '';

                return toolTipData;
            },
            style:{
                color:'#FFFFFF',
                fontSize: '12px',
                fontFamily: "Open Sans",
                opacity: 0.75
            }
        },
        series: [{
            column: {
                pointWidth: 20,
                color:'#007bff',
                borderColor: '#007bff',
                backgroundColor: '#007bff'
            },
            name: 'Retirement Funds',
            data: [
                ['2015', 2400000.2],
                ['2016', 2000000.8],
                ['2017', 1400000.9],
                ['2018', 1300000.7],
                ['2019', 1300000.1],
                ['2020', 1200000.7],
                ['2021', 1200000.4],
                ['2022', 1200000.2],
                ['2023', 1200000.0],
                ['2024', 1100000.7],
                ['2025', 1100000.6],
                ['2026', 1100000.5],
                ['2027', 1100000.2],
                ['2028', 1100000.1],
                ['2029', 1000000.6],
                ['2030', 1000000.6],
                ['2031', 1000000.6],
                ['2032', 1000000.3],
                ['2033', 900000.8],
                ['2034', 900000.3],
                ['2035', 90000.3]
            ],
            dataLabels: {
                enabled: false,
                rotation: -90,
                color: '#FFFFFF',
                align: 'right',
                format: '{point.y:.1f}', // one decimal
                y: 10, // 10 pixels down from the top
                style: {
                    color:'#FFFFFF',
                    fontSize: '12px',
                    fontFamily: "Open Sans"
                }
            }
        }]
    },
    HeaderTexts: {
        Married: [
            '<b>Personal Info:</b> Please choose single or married, then enter your names, date of birth and state of residence below.',
            '<b>Salaries & Retirement Date:</b> Choose whether you’re retired or working, then if working, your gross <strong>monthly</strong> salary and the date you’d like to retire.',
            '<b>Social Security:</b> Add the age you’d like to start and the projected <strong>monthly</strong> amounts of your Social Security benefits.',
            '<b>Pensions:</b> Add the age you’d like to start and the projected <strong>monthly</strong> amounts of your pension benefits.',
            '<b>Accounts for Retirement:</b> Enter the total of all IRAs, 401ks, 403bs, 457s, Seps, SIMPLEs, Profit Sharing Plans, ESOPs, etc. Also enter the total of any monthly contributions you are making to these accounts.',
            '<b>Other Accounts:</b> Enter the total of all checking, savings, investment and Roth accounts along with the contributions you are making to these accounts.',
            '<b>Rate of Return:</b> Add the average rate of return you feel you can attain on your accounts..',
            '<b>Monthly Expenses:</b> Enter the total amount of your monthly expenses.',
            '<b>Contact Info:</b> Provide your email address and your telephone number.'
        ],
        Single: [
            '<b>Personal Info:</b> Please choose single or married, then enter your name, date of birth and state of residence below.',
            '<b>Salaries & Retirement Date:</b> Choose whether you’re retired or working, then if working, your gross <strong>monthly</strong> salary and the date you’d like to retire.',
            '<b>Social Security:</b> Add the age you’d like to start and the projected <strong>monthly</strong> amount of your Social Security benefit.',
            '<b>Pensions:</b> Add the age you’d like to start and the projected <strong>monthly</strong> amount of your pension benefit.',
            '<b>Accounts for Retirement:</b> Enter the total of all IRAs, 401ks, 403bs, 457s, Seps, SIMPLEs, Profit Sharing Plans, ESOPs, etc. Also enter the total of any monthly contributions you are making to these accounts.',
            '<b>Other Accounts:</b> Enter the total of all checking, savings, investment and Roth accounts along with the contributions you are making to these accounts.',
            '<b>Rate of Return:</b> Add the average rate of return you feel you can attain on your accounts.',
            '<b>Monthly Expenses:</b> Enter the total amount of your monthly expenses.',
            '<b>Contact Info:</b> Provide your email address and your telephone number.'
        ]
    }
}

export const nineToKnowTemplatesList = [
  { id: '0', title: 'Template 1' },
  { id: '1', title: 'Template 2' },
  { id: '2', title: 'Template 3' },
  { id: '3', title: 'Template 4' }
];
